<template>
    <div v-if="productsOfRule.length">
        <span :data-vendor="productsOfRule[0].vendor"
              class="icon-vender"
              data-size="s"/>
        <span style="word-break: break-word;">
            {{ (autoExeYn === 'Y' && productsOfRule[0].prod) ? $t('PRODUCT.' + productsOfRule[0].prod) : $t('LABEL.MANUAL_RULE') }}
        </span>
        <div v-if="productsOfRule.length > 1">
            <button
                :data-tooltip-content="'#tooltip-products-' + ruleId"
                class="txt-status" data-status="key"
                data-trigger="tooltip-tbl"
                type="button"
            >
                {{ $t('POLICY.RULE.OTHER_COUNT', {prodCnt: productsOfRule.length - 1}) }}
            </button>
            <div class="tooltip_templates">
                <div :id="'tooltip-products-'+ ruleId">
                    <ul class="list-default">
                        <li v-for="(prod, index) of productsOfRule" :key="index">
                            <span>{{ $t('PRODUCT.' + prod.prod) }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import _ from "lodash";

export default {
    name: "RuleProducts",
    props: {
        ruleId: String,
        cndVal: Array,
        templateList: Array,
        autoExeYn: String,
    },
    mounted() {
        this.initProductToolTip();
    },
    computed: {
        productsOfRule() {
            let prodArray = [];
            if (this.templateList) {
                if (this.cndVal.length) {
                    for (let condition of this.cndVal) {
                        const conditionProd = _.find(this.templateList, {'tmpltId': condition.tmpltId});
                        let vendor = _.get(conditionProd, "vendor");
                        let prod = _.get(conditionProd, "prod");
                        vendor = this.Common.getVendorByKey(vendor);
                        prodArray.push({prod, vendor});
                    }
                } else {
                    prodArray.push({prod: "manual", vendor: "manual"});
                }
            }
            return _.unionBy(prodArray, "prod");
        }
    },
    methods: {
        initProductToolTip: function () {
            // 카테고리 라벨 & 프로덕트 목록 오버 툴팁
            $('[data-trigger="tooltip-tbl"]').tooltipster({
                delay: 300,
                animation: 'fade',
                updateAnimation: 'fade',
                side: 'bottom',
                theme: 'go-sizetofit',
                arrow: true,
                contentAsHTML: true,
            })
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/rule/ruleComponents/RuleProducts.vue